import React from 'react';
import classNames from 'classnames';
import { themr } from 'react-css-themr';
import { CdnContext } from '../../context';

import NewWordModal from './NewWordModal';
import baseNetworkActivityPickerTheme from './WordPicker.scss';

class NetworkActivityPicker extends React.Component {
    constructor(props) {
        super(props);

        const { max = -1 } = props;

        this.state = {
            max,
            chosenActivities: [],
            ...props,
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const {
            chosenActivities, part, section, setAnswer,
        } = this.state;
        const { data } = this.props;

        if (chosenActivities.length > 0) {
            const answer = {};
            answer[data.name] = chosenActivities;

            setAnswer({
                part,
                section,
                answer,
            });
        }
    }

    setInitialAnswer() {
        const { answer, onStateChange } = this.props;

        if (
            this.state.chosenActivities.length === 0 &&
            answer &&
            answer.length > 0
        ) {
            this.setState({
                chosenActivities: answer,
            });
            onStateChange(true);
        }
    }

    validState() {
        const { chosenActivities } = this.state;

        if (chosenActivities < 1) {
            return false;
        }

        return true;
    }

    isActivityChosen(activity) {
        return this.state.chosenActivities.indexOf(activity) > -1;
    }

    handleActivityClick(activity) {
        const { chosenActivities, max } = this.state;
        const { onStateChange } = this.props;

        if (this.isActivityChosen(activity)) {
            chosenActivities.splice(chosenActivities.indexOf(activity), 1);
        } else if (chosenActivities.length < max || max === -1) {
            chosenActivities.push(activity);
        }

        this.setState(
            {
                chosenActivities,
            },
            () => onStateChange(this.validState())
        );
    }

    handleAddActivity = (activity) => {
        const { activities, chosenActivities } = this.state;
        const { toggleModal } = this.props;

        activities.push(activity);
        chosenActivities.push(activity);

        this.setState({
            activities,
            chosenActivities,
        });

        toggleModal();
    };

    render() {
        const { activities } = this.state;
        const {
            data, theme, modalOpen, toggleModal, header,
        } = this.props;

        return (
            <div className={theme.wordPicker}>
                {data && (
                    <CdnContext.Consumer>
                        {cdn => (
                            <h2 className="question-heading">
                                <img
                                    src={`${cdn}assets/images/avatars/${
                                        data.avatar.filename
                                    }`}
                                    alt={data.name}
                                />
                                <span>
                                    {header.title.replace(
                                        '<person>',
                                        data.name
                                    )}
                                </span>
                            </h2>
                        )}
                    </CdnContext.Consumer>
                )}
                <div className={theme.wordPicker}>
                    {activities.map(activity => (
                        <div
                            key={activity}
                            onClick={() => {
                                this.handleActivityClick(activity);
                            }}
                            className={classNames('no-select word', theme.word, {
                                [theme.chosen]: this.isActivityChosen(activity),
                                chosen: this.isActivityChosen(activity),
                            })}
                        >
                            {activity}
                        </div>
                    ))}
                </div>
                <NewWordModal
                    onClose={toggleModal}
                    onAddWord={this.handleAddActivity}
                    open={modalOpen}
                />
            </div>
        );
    }
}

export default themr('networkActivityPicker', baseNetworkActivityPickerTheme)(NetworkActivityPicker);



// WEBPACK FOOTER //
// ./src/components/questions/NetworkActivityPicker.js